import React from 'react';
import Auth0Provider from '../../providers/Auth0Provider';
import { getEnvVariable } from '../../utils/envUtils';
import { Outlet } from 'react-router-dom';
const PublicRouter = () => (<Auth0Provider audience={getEnvVariable('auth0Audience')} clientID={getEnvVariable('auth0ClientId')} domain={getEnvVariable('auth0Domain')} logoutUrl={getEnvVariable('logoutUrl')} redirectUri={getEnvVariable('auth0RedirectUri')} userMetadataUrl={getEnvVariable('userMetadataUrl')} isPublic={true}>
    <Outlet />
  </Auth0Provider>);
export default PublicRouter;
